// NewProviderForm.js
import React, { useRef } from "react";
import { API_IP } from "../../env";
import axios from "axios";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal"; // Import Modal
import Geocode from "react-geocode";

Geocode.setApiKey("AIzaSyCzdRE9aePWE3Qq6p1sxlKuUeKo9Liiv2c");

Geocode.setLanguage("en");

Geocode.setLocationType("ROOFTOP");

// Accept 'show' and 'onHide'
function NewProviderForm({
  show,
  onHide,
  setRefreshProvider,
  refreshProvider,
}) {
  const provider_name = useRef();
  const address = useRef();
  const city = useRef();
  const province = useRef();
  const country = useRef();

  async function axiosReqConfig(url, method, data) {
    // ... (axiosReqConfig is the same)
    const bearerToken = localStorage.getItem("@uphealth_login_token");
    const reqConfig = {
      url: url,
      method: method,
      headers: { Authorization: `Bearer ${bearerToken}` },
      data: data,
    };
    const returnData = await axios(reqConfig);
    return returnData;
  }

  async function getLatLong() {
    const fullLocation = `${address.current.value}, ${city.current.value}, ${province.current.value}, ${country.current.value}`;

    try {
      const response = await Geocode.fromAddress(fullLocation);
      const { lat, lng } = response.results[0].geometry.location;

      await axiosReqConfig(`${API_IP}/api/admin/providers`, "post", {
        providerName: provider_name.current.value,
        address: address.current.value,
        city: city.current.value,
        province: province.current.value,
        country: country.current.value,
        lat: lat,
        long: lng,
      }); //

      setRefreshProvider(!refreshProvider);
      onHide(); // Close modal on success
    } catch (error) {
      alert("Geocode error or API error: " + error);
    }
  }

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Add New Provider</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Form>
            <Form.Group className="mb-3" controlId="formBasicName">
              <Form.Label>Provider Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter name of the provider"
                ref={provider_name}
              />
            </Form.Group>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="formBasicAddress">
                  <Form.Label>Address</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter address"
                    ref={address}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="formBasicCity">
                  <Form.Label>City</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter city"
                    ref={city}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="formBasicProvince">
                  <Form.Label>Province</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter province"
                    ref={province}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="formBasicCountry">
                  <Form.Label>Country</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter country"
                    ref={country}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="success" onClick={getLatLong}>
          Create New Provider
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default NewProviderForm;
